import TemplateView from '../../../../TemplateView'

export default class EntirelyAssignmentsBlock extends TemplateView {
    constructor() {
        super()

        this.state = {
            title: "",
            plusSelectedItemsText: "",
        }

        this.onStatePropertyChanged("title", title => {
            this.$entireTitle.text(title)
        })

        this.onStatePropertyChanged("plusSelectedItemsText", text => {
            this.$plusSelectedItems.text(text)
        })
    }

    templateHtml() {
        return "<div class='entirelyAssignmentsBlock'>" +
               "    <div class='entireTitle'></div>" +
               "    <div class='plusSelectedItems'></div>" +
               "</div>"
    }

    afterRender() {
        this.$entireTitle = this.find('.entireTitle')
        this.$plusSelectedItems = this.find('.plusSelectedItems')
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/hierarchyAssignmentsPanelTab/components/EntirelyAssignmentsBlock.js